import { createAction, createSlice } from "@reduxjs/toolkit";

const getDetailsCourseForUpdateSlice = createSlice({
  name: "getDetailsCourseForUpdate",
  initialState: { data: {}, processing: false, isSuccess: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload;
      state.processing = false;
      state.isSuccess = true;

      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    reset(state, action) {
      state.isSuccess = false;
    },
  },
});

const { name, actions, reducer } = getDetailsCourseForUpdateSlice;
const getDetailsCourseForUpdateAction = createAction(name);

export {
  getDetailsCourseForUpdateAction,
  actions as getDetailsCourseForUpdateActions,
  reducer as getDetailsCourseForUpdateReducer,
};
